<template>
  <div class="caption" :style="{ marginBottom: marginBottom }">
    <p class="left-cloud cloud"></p>
    <slot></slot>
    <p class="right-cloud cloud"></p>
  </div>
</template>

<script>
export default {
  name: "Caption",
  props: {
    marginBottom: {
      type: String,
      default: "0.6rem",
    },
  },
};
</script>

<style lang="less" scoped>
.caption {
  color: #000000;
  font-size: 0.5rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0.2rem 0 0.6rem;
  .cloud {
    width: 0.76rem;
    height: 0.3rem;
    background-size: contain;
  }
  .left-cloud {
    background-image: url("../assets/imgs/home/leftcloud@2x.png");
    margin-right: 0.2rem;
  }
  .right-cloud {
    background-image: url("../assets/imgs/home/rightcloud@2x.png");
    margin-left: 0.2rem;
  }
}
</style>